import httpToken from "./httpToken";
import GetEndPoints from "../api/AppSetting";
import axios from "axios";
import { stopInterval } from '../helper/cacheHelper';

class httpClient {
  baseURL: String;
  erro: boolean;
  errors: String[];
  _url: String;
  _token: String;
  _timeout: number;
  constructor(servico: string) {
    this.baseURL = GetEndPoints(servico);
    this.erro = false;
    this.errors = [];
    this._url = "";
    this._token = new httpToken().GetCachedToken();
    this._timeout = 1000 * 500;
  }

  /**
   * Cria os headers HTTP incluindo Ocp-Apim-Subscription-Key apenas em ambientes NÃO produção (DEV/QAS)
   */
  private getHeaders(): Record<string, string> {
    const headers: Record<string, string> = {
      "Content-Type": "application/json",
      authorization: `Bearer ${this._token}`,
    };

    // Adicionar Ocp-Apim-Subscription-Key apenas em DEV/QAS (NÃO em produção)
    if (process.env.REACT_APP_ENVIRONMENT !== 'production' && process.env.REACT_APP_ENVIRONMENT !== 'qas') {
      headers["Ocp-Apim-Subscription-Key"] = process.env.REACT_APP_OCP_APIM_KEY!;
    }

    return headers;
  }

  async Get(url: string): Promise<any> {
    this._token = new httpToken().GetCachedToken();
    return await axios
      .get(this.baseURL + url, {
        headers: this.getHeaders(),
      })
      .catch(function (error) {
        if (error.response.status === 401) {
          httpClient.Logout();
        }
        return error.response;
      });
  }

  async post(url: string, body: any) {
    var _url: string = `${this.baseURL}${url}`;
    const response = await axios
      .post(_url, body, {
        timeout: this._timeout,
        headers: this.getHeaders(),
      })
      .then()
      .catch(function (error) {
        console.error(error.response.data);
        console.error(error.response.status);
        console.error(error.response.headers);
        if (error.response.status === 401) {
          httpClient.Logout();
        }
        return error.response;
      });
    return response.data;
  }

  async put(url: string, body: any) {
    try {
      const response = await axios.put(`${this.baseURL}${url}`, body, {
        timeout: this._timeout,
        headers: {
          ...this.getHeaders(),
          charset: "utf-8",
        },
      });
      return response.data;
    } catch (err: any) {
      if (err.response.status === 401) {
        httpClient.Logout();
      }
      console.error(err);
    }
  }

  async putWithouTry(url: string, body: any) {
    const response = await axios
      .put(`${this.baseURL}${url}`, body, {
        timeout: this._timeout,
        headers: {
          ...this.getHeaders(),
          charset: "utf-8",
        },
      })
      .catch(function (error) {
        if (error.response.status === 401) {
          httpClient.Logout();
        }
        return error.response;
      });
    return response.data;
  }

  async patch(url: string, body: any) {
    try {
      const response = await axios
        .patch(`${this.baseURL}${url}`, body, {
          timeout: this._timeout,
          headers: this.getHeaders(),
        })
        .catch(function (error) {
          if (error.response.status === 401) {
            httpClient.Logout();
          }
          return error.response;
        });
      return response.data;
    } catch (err) {
      console.error(err);
    }
  }

  async delete(url: string, _body: any) {
    try {
      const response = await axios
        .delete(`${this.baseURL}${url}`, {
          timeout: this._timeout,
          data: _body,
          headers: this.getHeaders(),
        })
        .catch(function (error) {
          if (error.response.status === 401) {
            httpClient.Logout();
          }
          return error.response;
        });
      return response.data;
    } catch (err) {
      console.error(err);
    }
  }

  getUrl(): String {
    return String(`${this.baseURL}${this._url}`);
  }

  static Logout(): void {
    var logoutUrl =
      window.location.protocol +
      "//" +
      window.location.hostname +
      (window.location.port === "" ? "" : ":" + window.location.port) +
      "/";
    stopInterval();
    localStorage.clear();
    location.href = logoutUrl;
  }
}
export default httpClient;
